import { useState } from 'react';
import type { FlagReason } from '../state/model';
import { flag } from '../state/store';
import { Sheet } from './Sheet';
import { toast } from './Toast';

const REASONS: Array<{ value: FlagReason; label: string }> = [
  { value: 'greek', label: 'The Greek looks wrong' },
  { value: 'meaning', label: 'The meaning or word-by-word is off' },
  { value: 'audio', label: 'The audio sounds wrong' },
  { value: 'note', label: 'The note is wrong or unclear' },
  { value: 'other', label: 'Something else' },
];

interface Props {
  itemId: string;
  open: boolean;
  onClose: () => void;
  onFlagged?: () => void;
}

/** "Flag as wrong": takes the phrase out of practice and keeps the reason for the author. */
export function FlagSheet({ itemId, open, onClose, onFlagged }: Props) {
  const [reason, setReason] = useState<FlagReason>('greek');
  const [note, setNote] = useState('');

  return (
    <Sheet open={open} onClose={onClose} title="Flag this phrase as wrong">
      <p className="muted">
        The phrase leaves your practice until you withdraw the flag in Settings. Your progress on it is kept.
      </p>
      <div className="choice-list" role="radiogroup" aria-label="What's wrong?">
        {REASONS.map((r) => (
          <button key={r.value} type="button" role="radio" aria-checked={reason === r.value} className="choice" onClick={() => setReason(r.value)}>
            {r.label}
          </button>
        ))}
      </div>
      <label className="stack" style={{ gap: 6 }}>
        <span className="small muted">Details (optional)</span>
        <textarea className="text-input" value={note} onChange={(e) => setNote(e.target.value)} maxLength={500} />
      </label>
      <div className="stack">
        <button
          type="button"
          className="btn btn-primary btn-block"
          onClick={async () => {
            await flag(itemId, reason, note);
            onClose();
            toast('Flagged. It is out of your practice for now.');
            onFlagged?.();
          }}
        >
          Flag phrase
        </button>
        <button type="button" className="btn btn-ghost btn-block" onClick={onClose}>
          Cancel
        </button>
      </div>
    </Sheet>
  );
}
